import supreme from "../supreme";
import {getTimestamp} from "../util/util";
import _ from 'lodash'
import taskMgr from "./taskMgr";
const jType = {
  "FORAWRD":"FORAWRD",
  "GOTO":"GOTO",
  "REPLACE":"REPLACE"
}
/**
 *@desc 跳转回退集中管理对象
 *@author lei.you
 *@date 2018/02/08
 * */
export  default{
  //是否初始化
  hasInitlized:false,
  $router:null,
  defaultJumpPath:"/",
  // 页面刷新式加载，不是通过单页模式的加载
  jump(url){
    window.location=url;
  },
    /**
     * @description supreme 提供的跳转方式，不会记录到task中，
     * @param  pathname { string} 支持pathName ,name 两种方式
     * @param  params {object}需要携带的参数
     * */
  forward(pathName, params = {}){
      params.jType=jType.FORAWRD;
      //this.$router.push(pathName,params);
      this._forward(pathName,params);
  },

    /**
     * @description supreme 提供的跳转方式，不会记录到task中，
     * @param  pathname { string} 支持pathName ,name 两种方式
     * @param  params {object}需要携带的参数
     * */
    _forward(pathName, params = {}){
        var paramsStr="";
        if (!_.isEmpty(params)) {
            paramsStr = supreme.param(params);
        }
        // var route = this._matchRouteByName(pathName);
        this.$router.push(pathName+ "?" + paramsStr)
    },
    _replace(pathName,params={}){
        var paramsStr="";
        if (!_.isEmpty(params)) {
            paramsStr = supreme.param(params);

        }
        this.$router.replace(pathName+ "?" + paramsStr);
    },
    replace(pathName, params = {}) {
        if (!this.$router) {
            throw "use this function must has vue router module";
            return;
        }
        params.jType=jType.REPLACE;
        var router = this.$route;
        params.url_gid = getTimestamp();
        params.isForward = true;
        var p={
            pathName:pathName,
            params:params
        }
        taskMgr.pop()
        var task = taskMgr.add(p);
        if(params.useCache!=undefined){
            this._useCache(task,params.useCache);
        }
        supreme._isPopState=false;
        if (!_.isEmpty(params)) {
            this._replace(pathName,params);
        } else {
            this._replace(pathName);
        }

    },
  /**
   * @description supreme 提供的跳转方式，会记录到taskStack中
   * @param pathName {string} 支持pathName ,name 两种方式
   * @param params {object}  useCache:true||false 动态指定下个页面是否使用缓存
   *
   * */
  goto(pathName, params = {}) {
    if (!this.$router) {
      throw "use this function must has vue router module";
    }

    var route = this.$route;
    params.jType=jType.GOTO;
    params.url_gid = getTimestamp();
    params.isForward = true;
    var p={
      pathName,
      params:params
    }
    var task = taskMgr.add(p);
    if(params.useCache!=undefined){
      this._useCache(task,params.useCache);
    }
    supreme._isPopState=false;
    if (!_.isEmpty(params)) {
      this._forward(pathName,params);
    } else {
      this._forward(pathName.path);
    }
    /**
    setTimeout(()=>{

      if (params.clearCache) {
        task.vue.clearCache();
      }

    })
     */

  },
  /**
   * @task task
   * @keepAlive 是否使用缓存
   * */
  _useCache(task,keepAlive){
    task.keepAlive=keepAlive;
    var router = this.$router;
    for(let[index,item] of router.options.routes.entries()){
      if(item.path.replace("/","")==task.pathName.replace("/","")){
        if(!item.meta){
          item.meta={};
        }
        item.meta.keepAlive = keepAlive;
        break;
      }
    }
  },
    /**
     * @description 帮助匹配路径，支持 pathName , name 两种方式跳转
     *
     * */
  _matchRouteByName(name){
    var router = this.$router;
    var route = null;
    for(let[index,item] of router.options.routes.entries()){
        if(item.path.replace("/","")==name.replace("/","")||(item.name&&(item.name.replace("/","")==name.replace("/","")))){
           route=item;
            break;
        }
    }
    return route;
  },
  /**
   * @description 回退到某一个页面
   * @param  model ={
     *            step, 指定回退 步数  正整数
     *            name, 指定回退到最近的指定名字的task
     *            step name 不能同时指定，如果同时指定会优先step
     *            clearCache true false 是否清缓存
     *          }
   * @param params 回退携带的参数
   *
   *
   * */
  backToPage(model = {}, params= {}) {
    var task;
    if (_.isEmpty(model) || (!model)) {
      this.back();
      return;
    }
    if (model.step > 0) {
      var type = "^[0-9]*[1-9][0-9]*$";
      var r = new RegExp(type);
      var flag = r.test(model.step);
      if (!flag) {
        supreme.showToast("step 参数必须是正整数")
        return;
      }
      task = taskMgr.backToTaskByStep(model.step);
    } else if (model.name) {
      task = taskMgr.backToTaskByName(model.name);
    }
    if (!task) {
      //supreme.showToast("无法回退因为没有浏览历史");
      this._forward(this.defaultJumpPath||'index');
      return;
    }

    if(task&&params.useCache!=undefined){
      this._useCache(task,params.useCache);
    }
    if (task&&task.vue&&model.clearCache) {
      task.vue.clearCache();
    }
    delete task.params.isForward;
    //var p = supreme.$.extend({}, task.params, params);

    var p = _.assign({},task.params,params);
    this._forward(task.pathName,p)
  },
  /**
   * @description 回退上个页面
   * @pamams.useCache 回退到的页面是否使用缓存
   * @params.clearCache 清除掉回退到页面的缓存
   * */
  back(params = {}) {
    if (!this.$router) {
      throw "use this function must has vue router module";
    }
    taskMgr.pop();
    var task = taskMgr.getLastTask();
    if(task&&params.useCache!=undefined){
      this._useCache(task,params.useCache);
    }
    if (task&&task.vue&&params.clearCache) {
      task.vue.clearCache();
    }
    if (!task) {
      //supreme.showToast("无法回退因为没有浏览历史");
      this._forward(this.defaultJumpPath||'index');
      return;
    }
    delete task.params.isForward;
    //var p = supreme.$.extend({}, task.params, params);
    var p = _.assign({},task.params,params);
    this._forward(task.pathName,p);
  },
  init(config){
    //supreme.$.extend(this,config);
    _.extend(this,config);
    if(!this.hasInitlized){
      this.hasInitlized=true;
      //处理浏览器自带的back forward 才会触发onpopstate 事件 history.pushState()或history.replaceState()不会触发popstate事件。只有在做出浏览器动作时，才会触发该事件
      // 通过项目中的实践，不能够兼容浏览器前进按钮。
      var self=this;
      //解决浏览器回退
      window.onpopstate=function(stateEvent){
        //supreme.goto("index");
        var direction = taskMgr.getBrowserDirection();
        supreme._isPopState=true;
        /**
        if(direction=="back"){
          taskMgr.pop();
        }else{
          if(!getQueryString("url_gid")){
            return ;
          }else{
            var t = taskMgr.getTaskInAbandonTaskStack(getQueryString("url_gid"));
            taskMgr.addTask(t);
          }
        }
         */
        /**
         * 注意 state 在 safari 和ff 下的情况！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * ！！！！！！！！！！！！！！！！！！！！！！！
         * */
        /**
         *  暂时注释掉，supreme 中禁止浏览器使用前进功能
        if(!stateEvent.state){
          taskMgr.clear();
          //window.location.reload();
          return ;
        }
         */
        var oldTask = taskMgr.pop();
        var task = taskMgr.getLastTask();
        if(task){
          //目前只考虑浏览器回退的情况
          if(task.params){
            delete task.params.isForward;
          }
          task.params.timeStamp = supreme.getTimestamp();
          // 触发浏览器回退调用注册的回调
          oldTask.webBrowserBackCallback();
          supreme.replace(task.pathName,task.params);
        }else{
          supreme.goto(oldTask.pathName);
        }


      };
    }

  }

}
